import React from 'react';

import {getFileThumbnailUrl, getFileUrl} from 'mattermost-redux/utils/file_utils';
import {type FileInfo} from 'mattermost-redux/types/files';

import Constants, {FileTypes} from 'utils/constants';
import {getFileType, getIconClassName, isGIFImage} from 'utils/utils';

type Props = {
    fileInfo: FileInfo;
};

export default class FileThumbnail extends React.PureComponent<Props> {
    render() {
        const {fileInfo} = this.props;
        const type = getFileType(fileInfo.extension);

        const isImageWithPreview = type === FileTypes.IMAGE && fileInfo.has_preview_image;
        const isGIF = isGIFImage(fileInfo.extension);

        if (isImageWithPreview || isGIF) {
            let className = 'post-image';

            if (fileInfo.width < Constants.THUMBNAIL_WIDTH && fileInfo.height < Constants.THUMBNAIL_HEIGHT) {
                className += ' small';
            } else {
                className += ' normal';
            }

            const thumbnailUrl = isGIF ? getFileUrl(fileInfo.id) : getFileThumbnailUrl(fileInfo.id);

            return (
                <div
                    className={className}
                    style={{
                        backgroundImage: `url(${thumbnailUrl})`,
                        backgroundSize: 'cover',
                    }}
                />
            );
        }

        return <div role='img' className={'file-icon ' + getIconClassName(type)} />;
    }
}
